import { createContext, useContext } from 'react'
import type { CollectedMetadata } from './types'

const MetadataCollectorContext = createContext<CollectedMetadata | null>(null)

export function MetadataCollectorProvider({
    collector,
    children,
}: {
    collector: CollectedMetadata
    children: React.ReactNode
}) {
    return (
        <MetadataCollectorContext.Provider value={collector}>
            {children}
        </MetadataCollectorContext.Provider>
    )
}

export function useMetadataCollector() {
    return useContext(MetadataCollectorContext)
}
